import { createTheme } from '@mui/material/styles';
import 'typeface-roboto';
import { palette } from 'assets/theme/palette';

const theme = createTheme({
    palette: palette(),
    typography: {
        fontFamily: 'Roboto',
        htmlFontSize: 18
    }
});

export default theme;
